// extracted by mini-css-extract-plugin
module.exports = {"downloadOptions":"downloadDropdown_downloadOptions__3Sr_R","active":"downloadDropdown_active__3jgp6"};